/**
 * Sync 口型同步 —— capability 元数据
 */
export default {
  id: 'sync',
  nodeType: 'video',
  label: 'Sync 口型同步',
  description: '源视频 + 驱动音频,替换人物口型并输出新视频。',
}
